<ng-container *transloco="let t">
<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center">{{ t('portal.tasks.addFiles') }}</h5>
  <button
    type="button"
    class="btn-close"
    (click)="activeModal.dismiss()"
    aria-label="Close"
  ></button>
</div>

<div class="modal-body">
  <form>
    <file-upload (uploadClicked)="onUploadClicked($event)" [isUploading]="isUploading"></file-upload>
    <div class="mt-3">
      <label class="form-label fw-bold">{{ t('portal.tasks.note') }}</label>
      <textarea class="form-control" rows="2" [(ngModel)]="borrowerNote" [ngModelOptions]="{standalone: true}"></textarea>
    </div>
  </form>
</div>
</ng-container>
